// src/pages/PrivacyPolicyPage.js

import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';


const PrivacyPolicyPage = () => {
    return (
        <Fragment>
            <main className="page_content privacy-policy-page">
                <PageTitle pageTitle={'Privacy Policy & Legal Terms'} pagesub={''} pageTop={''} />
                <div className="container py-5">
                   
                    <p>
                        <b>Company Name:</b> Laskon Technologies Ltd <br />
                        <b>Company Registration Number:</b>[16109655] <br />
                        <b>Registered in:</b> England and Wales <br />
                        <b>Registered Office:</b> Unit 1, Parliament Business Centre, Commerce Way,
                        Liverpool, L8 7BL <br />
                        <b>Contact Email:</b> info@laskontechnologies.com
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>1. Overview</b>
                    </p>
                    <p>
                        This Privacy Policy and accompanying Legal Terms explain how <b> Laskon Technologies Ltd </b>
                        ("we", "our",  "us") collects, uses, shares, and protects information, and
                        sets  forth the conditions under which we deliver our services and protect
                        ourselves  from legal and operational liability.
                    </p>
                    <p>
                        By interacting with our company, website, services,  representatives, or
                        engaging with any of our solutions (AI, cybersecurity,  software, mobile
                        apps, web platforms, business consulting, etc.), <b> you accept  and agree to the terms described herein. </b>
                    </p>
                    <p>

                    </p>
                    <p>
                        <b>2. Scope of Application</b>
                    </p>
                    <p>
                        These terms apply to <b>all engagements</b>, including but  not limited to:
                    </p>
                    <ul type="disc">
                        <li>
                            Digital interactions (website, email, software,       online forms)
                        </li>
                        <li>
                            Client projects (web, AI, cybersecurity, data       science, mobile
                            apps)
                        </li>
                        <li>
                            Physical meetings, verbal agreements, and BD-led       initiatives
                        </li>
                        <li>
                            Third-party platforms or tools offered on our behalf
                        </li>
                    </ul>
                    <p>
                        This includes actions or proposals made by <b>
                            employees,  contractors, consultants, business development (BD)
                            personnel
                        </b>
                        , or any  affiliate working on behalf of Laskon Technologies Ltd.
                    </p>
                    <p>
                        ⚠️
                        <b>
                            All services and dealings,  whether formal, informal, physical or
                            digital, are subject to these terms.
                        </b>
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>3. Data We Collect</b>
                    </p>
                    <p>
                        In compliance with the <b>UK GDPR and Data Protection Act  2018</b>, we
                        collect:
                    </p>
                    <p>
                        <b>a. Personal Data</b>
                    </p>
                    <ul type="disc">
                        <li>
                            Name, phone number, email, company, job title
                        </li>
                        <li>
                            ID documents (if required for verification)
                        </li>
                    </ul>
                    <p>
                        <b>b. Technical Data</b>
                    </p>
                    <ul type="disc">
                        <li>
                            IP address, device ID, cookies, access logs
                        </li>
                        <li>
                            Browser and OS information
                        </li>
                    </ul>
                    <p>
                        <b>c. Service Data</b>
                    </p>
                    <ul type="disc">
                        <li>
                            Project details, feedback, technical communications
                        </li>
                        <li>
                            Usage logs, code repositories (if hosted with us),       support tickets
                        </li>
                    </ul>
                    <p>
                        <b>d. Financial Data</b>
                    </p>
                    <ul type="disc">
                        <li>
                            Bank details (if needed for invoicing)
                        </li>
                        <li>
                            Payment confirmations, billing records
                        </li>
                    </ul>
                    <p>
                        <b>e. Communication Data</b>
                    </p>
                    <ul type="disc">
                        <li>
                            Emails, call transcripts, chat logs, meeting notes
                        </li>
                    </ul>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>4. Purpose of Processing</b>
                    </p>
                    <p>
                        We use the data for:
                    </p>
                    <ul type="disc">
                        <li>
                            Fulfilling contracts and service delivery
                        </li>
                        <li>
                            Verifying identity and communication
                        </li>
                        <li>
                            Managing business development and support
                        </li>
                        <li>
                            Internal audits, R&amp;D, and improvement of our       services
                        </li>
                        <li>
                            Legal compliance and protection from risk or fraud
                        </li>
                    </ul>
                    <p>
                        🛡️ All processing is done  under one or more legal bases outlined in <b>
                            Article 6 of the UK GDPR
                        </b>
                        .
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>5. Security and Data Protection</b>
                    </p>
                    <p>
                        We apply the <b>ISO/IEC 27001</b> framework and follow  industry best
                        practices, including:
                    </p>
                    <ul type="disc">
                        <li>
                            End-to-end encryption
                        </li>
                        <li>
                            Access control and two-factor authentication
                        </li>
                        <li>
                            Secure backups and cloud security protocols
                        </li>
                        <li>
                            Role-based permissions for internal access
                        </li>
                        <li>
                            Regular penetration testing
                        </li>
                    </ul>
                    <p>
                        However, no system is 100% secure. We cannot be held liable  for <b>
                            incidents caused by third-party providers
                        </b>
                        , <b>client-side  misconfigurations</b>, or <b>
                            external attacks outside our control
                        </b>
                        .
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>6. Client Responsibilities</b>
                    </p>
                    <p>
                        Clients engaging with Laskon Technologies Ltd agree to:
                    </p>
                    <ul type="disc">
                        <li>
                            Provide accurate, timely information
                        </li>
                        <li>
                            Respond to communication promptly
                        </li>
                        <li>
                            Assign clear decision-makers
                        </li>
                        <li>
                            Avoid giving vague or shifting requirements
                        </li>
                    </ul>
                    <p>
                        ⚠️ Any delays, reduced project  quality, or missed deliverables caused by <b>
                            client-side delays or  miscommunication shall not be our responsibility.
                        </b>
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>7. No Timeline Guarantees</b>
                    </p>
                    <p>
                        We operate with flexibility in delivery to handle real-world
                        unpredictability including:
                    </p>
                    <ul type="disc">
                        <li>
                            Technical blockers
                        </li>
                        <li>
                            Dependency failures
                        </li>
                        <li>
                            Staff illness or resource constraints
                        </li>
                        <li>
                            Global events, acts of government, or force majeure
                        </li>
                    </ul>
                    <p>
                        <b>
                            No delivery timelines are binding unless clearly stated  in a signed
                            written contract
                        </b>
                        <b>after two weeks of actual proposed time.</b>
                    </p>
                    <p>
                        Verbal or informal estimates from sales staff, project  managers, or
                        developers <b>are non-binding</b>
                        <b>
                            cannot be used to claim delay  penalties or refunds.
                        </b>
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>8. Disclaimer of Warranties</b>
                    </p>
                    <p>
                        Laskon Technologies Ltd provides services "as is"  without express or
                        implied warranties. This includes, but is not limited to:
                    </p>
                    <ul type="disc">
                        <li>
                            Warranties of merchantability
                        </li>
                        <li>
                            Fitness for a particular purpose
                        </li>
                        <li>
                            Accuracy, completeness, or non-infringement
                        </li>
                    </ul>
                    <p>
                        We do <b>not</b> <b>
                            100% guarantee specific results, business outcomes, or financial  impact
                        </b> from our services. All services are rendered based on best-effort  and
                        professional diligence.
                    </p>
                    <p>

                    </p>
                    <p>
                        <b>9. Limitation of Liability</b>
                    </p>
                    <p>
                        To the <b>maximum extent permitted by law</b>, Laskon  Technologies Ltd
                        shall <b>not be liable for</b>:
                    </p>
                    <ul type="disc">
                        <li>
                            Any indirect, incidental, special, punitive, or       consequential
                            damages
                        </li>
                        <li>
                            Loss of profits, revenue, contracts, data, or       reputation
                        </li>
                        <li>
                            Disruptions caused by third-party software/tools used       in your
                            project
                        </li>
                        <li>
                            Cybersecurity breaches not arising from our own       direct negligence
                        </li>
                    </ul>
                    <p>
                        Liability is <b>
                            capped at the total amount paid by the  client for the specific service
                        </b>
                        over the last 3 months.
                    </p>
                    <p>

                    </p>
                    <p>
                        <b>10. Indemnity Clause</b>
                    </p>
                    <p>
                        Clients agree to <b>indemnify and hold harmless Laskon  Technologies Ltd</b>
                        , its directors, employees, agents, and contractors from  any and all:
                    </p>
                    <ul type="disc">
                        <li>
                            Claims, losses, demands, legal proceedings, or       investigations
                        </li>
                        <li>
                            Resulting from misuse of our services, IP violations,       or
                            third-party liabilities caused by client-side actions or negligence
                        </li>
                    </ul>
                    <p>
                        💼 <b>We reserve the right  to pursue legal compensation</b> in case of
                        defamation, misuse of confidential  data, or reputational harm caused by
                        false public claims.
                    </p>
                    <p>

                    </p>
                    <p>
                        <b>11. Force Majeure</b>
                    </p>
                    <p>
                        We shall not be held liable for <b>any failure or delay</b> resulting from:
                    </p>
                    <ul type="disc">
                        <li>
                            Natural disasters, pandemics, civil unrest
                        </li>
                        <li>
                            Cyberattacks or internet downtime
                        </li>
                        <li>
                            Power outages, supplier failure
                        </li>
                        <li>
                            Governmental or legal restrictions
                        </li>
                    </ul>
                    <p>
                        Such events <b>
                            release us from all obligations without  penalty or liability
                        </b>
                        .
                    </p>
                    <p>

                    </p>
                    <p>
                        <b>12. Third-Party Integrations</b>
                    </p>
                    <p>
                        We may use third-party software (e.g., APIs, cloud services,  SDKs) to
                        deliver part of your solution. We are <b>
                            not liable for bugs, delays,  or vulnerabilities originating from
                        </b>
                        :
                    </p>
                    <ul type="disc">
                        <li>
                            Third-party software providers
                        </li>
                        <li>
                            Open-source dependencies
                        </li>
                        <li>
                            Hosting or platform downtimes (e.g., AWS, Azure,       GitHub, Firebase)
                        </li>
                    </ul>
                    <p>
                        Clients are responsible for obtaining commercial licenses  where applicable.
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>13. Employee &amp; Representative Disclaimer</b>
                    </p>
                    <p>
                        Laskon Technologies Ltd <b>is not bound by informal  representations</b> made by:
                    </p>
                    <ul type="disc">
                        <li>
                            Business development executives
                        </li>
                        <li>
                            Sales consultants
                        </li>
                        <li>
                            Technical engineers or support agents
                        </li>
                    </ul>
                    <p>
                        <b>
                            Only signed documents and official emails from company  officers are
                            considered binding.
                        </b>
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>14. Your Rights Under UK GDPR</b>
                    </p>
                    <p>
                        You have the right to:
                    </p>
                    <ul type="disc">
                        <li>
                            Access your data
                        </li>
                        <li>
                            Request rectification or erasure
                        </li>
                        <li>
                            Restrict or object to processing
                        </li>
                        <li>
                            Request data portability
                        </li>
                    </ul>
                    <p>
                        Contact us at <b>privacy@laskontech.com</b>. We aim to  respond within 30
                        days in accordance with <b>ICO guidelines</b>.
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>15. Cookies &amp; Web Tracking</b>
                    </p>
                    <p>
                        Our website uses:
                    </p>
                    <ul type="disc">
                        <li>
                            Essential cookies for site functionality
                        </li>
                        <li>
                            Analytics cookies (e.g., Google Analytics)
                        </li>
                        <li>
                            Session tracking for performance improvement
                        </li>
                    </ul>
                    <p>
                        You may opt out via your browser settings or through our  cookie consent
                        banner.
                    </p>
                    <p>
                        More info: ICO Cookies Guidance
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>16. International Data Transfers</b>
                    </p>
                    <p>
                        Where required, we may store or process data outside the UK,  including in
                        jurisdictions that the UK deems to offer adequate protection (UK  Adequacy
                        Regulations). We ensure contracts include Standard Contractual Clauses
                        where required.
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>17. Updates to This Policy</b>
                    </p>
                    <p>
                        We reserve the right to update this Privacy Policy and Legal  Disclaimer at
                        any time. Clients and users are encouraged to review it  regularly. Major
                        changes will be communicated via email or website  announcements.
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>
                    <p>
                        <b>18. Governing Law</b>
                    </p>
                    <p>
                        This policy and any disputes arising under it are governed  by the <b>
                            laws of England and Wales
                        </b>
                        . All disputes shall be resolved  exclusively in the courts of the United
                        Kingdom.
                    </p>
                    <div align="center">
                        <hr
                            size="2" width="100%" align="center" />
                    </div>

                    {/* ===== GAME DEVELOPMENT PRIVACY POLICY ===== */}
                    <h2 className="mt-5 mb-3" style={{ fontWeight: 'bold' }}>
                        Privacy Policy for Laskon Technologies — Game Development
                    </h2>
                    <p><b>Last Updated:</b> March 31, 2026</p>
                    <p>
                        Laskon Technologies ("we," "us," or "our") develops high-quality mobile games.
                        This section applies to all games published by Laskon Technologies (each, a "Game").
                        We operate under a <b>"Privacy by Design"</b> model, meaning we do not collect or monetize your personal data.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>19. Data Transparency (Apple Privacy Labels)</b></p>
                    <p>In compliance with Apple's App Privacy requirements, we declare the following:</p>
                    <ul type="disc">
                        <li>
                            <b>Data Not Collected:</b> Our Game does not collect any data from you.
                            We do not collect names, emails, physical addresses, or precise location data.
                        </li>
                        <li>
                            <b>Data Not Linked to You:</b> We do not collect identifiers (such as IDFA
                            or Device ID) to link to your identity.
                        </li>
                        <li>
                            <b>No Tracking:</b> We do not track you across other apps or websites.
                        </li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>20. AI and Automated Processing (2026 Standard)</b></p>
                    <p>
                        We do not share any user gameplay data with third-party Artificial Intelligence (AI)
                        models. No "Generative AI" is used to process or store your personal information within
                        any of our Games.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>21. Third-Party Services (Games)</b></p>
                    <p>Our Games may use standard platform services:</p>
                    <ul type="disc">
                        <li>
                            <b>Apple Game Center / Google Play Games:</b> For leaderboards and achievements.
                            These services are governed by Apple's and Google's own privacy policies.
                            We do not store this data on Laskon Technologies' servers.
                        </li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>22. Children's Privacy (COPPA &amp; UK GDPR)</b></p>
                    <p>
                        Our Games are safe for all ages. We do not knowingly collect personal information
                        from children under 13 (or 16 in the UK/EU). Our Games do not contain
                        "behavioral advertising," making them fully compliant with the Children's Online
                        Privacy Protection Act.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>23. Account &amp; Data Deletion (Games)</b></p>
                    <ul type="disc">
                        <li>
                            <b>In-App:</b> Our Games do not require an account. All game progress is
                            stored locally on your device. To delete all data, simply uninstall the app.
                        </li>
                        <li>
                            <b>Manual Request:</b> To request the removal of any support emails you
                            have sent us, contact <b>sales@laskontech.com</b>.
                        </li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    <p><b>24. Contact Information (Games)</b></p>
                    <p>
                        Laskon Technologies<br />
                        Unit 1, Parliament Business Centre, Commerce Way<br />
                        Liverpool, L8 7BL, United Kingdom<br />
                        Email: <b>sales@laskontech.com</b>
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>

                    {/* <p>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        comments
                        <br />
                        <br />
                        <br />
                        <i>
                            "As one of the UK’s leading sustainable packaging providers,  Green Bell
                            Packaging has significantly benefited from our collaboration with
                            Laskon Technologies. Their team played a crucial role in streamlining
                            our  R&amp;D processes and enhancing our innovation pipeline. Their
                            ability to  understand our vision and transform it into scalable,
                            tech-driven solutions has  made a tangible difference in how we build
                            and deliver next-generation  packaging."
                        </i>
                        <br />
                        <b>
                            – Green Bell Packaging
                        </b>
                        <b>    <br />
                            <br />
                            V nagori
                            <br />
                        </b>    <b>    <img
                            width="172"
                            height="61"
                            src={green}
                        />
                        </b><b> <br />
                            <br />
                            <br />
                        </b>
                        <i>
                            Laskon Technologies has been a pivotal move for Stratton Tea.  Their
                            strategic and tech-driven approach has helped us identify high-value
                            potential leads and expand our market reach with precision. More
                            importantly,  their team has provided consistent support in building the
                            digital and  operational backbone for our two upcoming tea and coffee
                            brands. From market  insights to technical execution, they’ve been
                            instrumental in ensuring a strong  foundation for our next phase of
                            growth."
                        </i>
                        <br />
                        <b>
                            – Stratton Tea
                        </b>
                        <b>    <br />
                            <br />
                            Razi K
                        </b>    <b>    <img
                            width="194"
                            height="48"
                            src={stratten}
                        />
                        </b><b> <br />
                            <br />
                        </b> <i></i>
                    </p> */}
                    {/* <p>
                        <i> </i>
                    </p>
                    <p>
                        <i> </i>
                    </p> */}
                    {/* <p>
                        <i>
                            Laskon Technologies has brought a powerful digital edge  to our real
                            estate and construction operations. Their tailored tech solutions
                            helped us attract qualified leads, improve client engagement, and
                            optimize the  way we present our projects online. From virtual property
                            showcases to CRM  integration and automation, their support has resulted
                            in faster deal closures  and a more streamlined buyer journey. They
                            understand the real estate space  deeply and deliver results that
                            matter."
                        </i>
                        <br />
                        <b>– Bida Homes &amp; Construction</b>
                        <b>
                            <br />
                            <br />
                            Andrew T
                        </b><b>
                            <img
                                width="144"
                                height="66"
                                src={bidaHomes}
                            />
                        </b>
                    </p> */}

                    {/* Game Development Privacy Policy */}
                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <h2 className="mt-5 mb-3"><b>Privacy Policy for Laskon Technologies — Game Development</b></h2>
                    <p><i>Last Updated: March 31, 2026</i></p>
                    <p>
                        Laskon Technologies ("we," "us," or "our") develops high-quality mobile games.
                        This Privacy Policy applies to our Games. We operate under a "Privacy by Design"
                        model, meaning we do not collect or monetize your personal data.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>1. Data Transparency (Apple Privacy Labels)</b></p>
                    <p>In compliance with Apple's App Privacy requirements, we declare the following:</p>
                    <ul type="disc">
                        <li><b>Data Not Collected:</b> Our Games do not collect any data from you. We do not collect names, emails, physical addresses, or precise location data.</li>
                        <li><b>Data Not Linked to You:</b> We do not collect identifiers (such as IDFA or Device ID) to link to your identity.</li>
                        <li><b>No Tracking:</b> We do not track you across other apps or websites.</li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>2. AI and Automated Processing (2026 Standard)</b></p>
                    <p>
                        We do not share any user gameplay data with third-party Artificial Intelligence (AI)
                        models. No "Generative AI" is used to process or store your personal information
                        within our Games.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>3. Third-Party Services</b></p>
                    <p>Our Games may use standard platform services:</p>
                    <ul type="disc">
                        <li>
                            <b>Apple Game Center / Google Play Games:</b> For leaderboards and achievements.
                            These services are governed by Apple's and Google's own privacy policies.
                            We do not store this data on Laskon Technologies' servers.
                        </li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>4. Children's Privacy (COPPA &amp; UK GDPR)</b></p>
                    <p>
                        Our Games are safe for all ages. We do not knowingly collect personal information
                        from children under 13 (or 16 in the UK/EU). Our Games do not contain "behavioral
                        advertising," making them fully compliant with the Children's Online Privacy
                        Protection Act.
                    </p>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>5. Account &amp; Data Deletion</b></p>
                    <ul type="disc">
                        <li>
                            <b>In-App:</b> Our Games do not require an account. All game progress is stored
                            locally on your device. To delete all data, simply uninstall the app.
                        </li>
                        <li>
                            <b>Manual Request:</b> To request the removal of any support emails you have
                            sent us, contact <b>sales@laskontech.com</b>.
                        </li>
                    </ul>

                    <div align="center">
                        <hr size="2" width="100%" align="center" />
                    </div>
                    <p><b>6. Contact Information</b></p>
                    <p>
                        Laskon Technologies<br />
                        Unit 1, Parliament Business Centre, Commerce Way<br />
                        Liverpool, L8 7BL, United Kingdom<br />
                        Email: <b>sales@laskontech.com</b>
                    </p>

                </div>
            </main>
            <Scrollbar />
        </Fragment>
    );
};

export default PrivacyPolicyPage;
